function loadSlides($tab) {
    const link = $tab.data('link');
    const $holder = $('.js-group-slider-holder');

    if ($holder.hasClass('is-loading')) {
        return;
    }

    $('.js-group-slider-trigger.is-active').removeClass('is-active');
    $tab.addClass('is-active');

    $holder.addClass('is-loading');

    $.get(link, {}, function(html) {
        $holder.empty();
        $holder.html(html);

        requestAnimationFrame(function() {
            $slider = $holder.find('.js-tab-products-slider');

            if ($slider) {
                $slider.slick({
                    dots: true,
                    arrows: true,
                    infinite: false,
                    adaptiveHeight: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: $slider.parent().find('.slick-prev'),
                    nextArrow: $slider.parent().find('.slick-next'),
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2.2,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 550,
                            settings: {
                                slidesToShow: 1.8,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 370,
                            settings: {
                                slidesToShow: 1.6,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                })
                .on('setPosition', function(event, slick) {
                    bLazy.revalidate();

                    slick.$slides.find('.slider__products__list__item')
                        .css('height', 'auto')
                        .css('height', slick.$slideTrack.height() + 'px');
                });

                requestAnimationFrame(function() {
                    bLazy.revalidate();
                    $slider.slick('setPosition')
                });
            }

            $holder.removeClass('is-loading');
        });
    });
}

$(function() {
    if ($('.js-group-slider').length) {
        // loadSlides($('.js-group-slider-trigger.is-active'));

        $('.js-group-slider-trigger').on('click', function() {
            // loadSlides($(this));
        });
    }
});

